module.exports = __webpack_public_path__ + "img/loading.69d2269c.gif";